import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

export interface Instalacao {
  ambiente_nfce?: string;
  apelido: string;
  automatic_billing: number;
  automatic_increase: number;
  avatar?: string;
  bairro?: string;
  billing_method: string;
  billing_status: number;
  billing_status_v2: string;
  billing_unlock?: string;
  cep?: string;
  certificado_base64?: string;
  chave_ativacao: string;
  cidade?: string;
  cnf_nfe: number;
  cnpj: string;
  cod_cidade?: string;
  country: string;
  crt?: string | number;
  csc_h?: string;
  csc_p?: string;
  currency: string;
  data_alt: Date;
  data_computador?: Date;
  data_del?: Date;
  data_inc?: Date;
  data_ultima_venda?: Date;
  data_validade?: Date;
  email: string;
  endereco: string;
  estado?: string;
  exige_termo?: boolean;
  fiscal: number;
  franchise_id: number;
  galaxpay_billing: number;
  galaxpay_extend: Date;
  id_token_h?: string;
  id_token_p?: string;
  idi: number;
  inscricao_estadual?: string;
  inscricao_municipal?: string;
  marketplace_id?: string;
  marketplace_token?: string;
  modulo_bot: number;
  modulo_emissor: number;
  modulo_mesa: number;
  nnf_h?: number;
  nnf_p?: number;
  nome_certificado?: string;
  nome_fantasia?: string;
  numero?: number;
  origin?: string;
  pagpop_token?: string;
  picpay_token?: string;
  pipefy_current_phase?: string;
  razao_social?: string;
  responsible_name?: string;
  responsible_whatsapp_phone?: string;
  responsible_verified_at?: Date | string;
  segundo_caixa?: number;
  senha_certificado?: string;
  serie_h?: string;
  serie_p?: string;
  telefone?: string;
  timezone: string;
  token?: string;
  ultima_conexao_ws?: string;
  usuario_alt?: string | number;
  usuario_inc?: string | number;
  versao_sistema?: string;
  version_electron?: string;
  yooga_customer_id?: string;
  zoop_seller_id?: string;
  allow_waiters?: boolean;
  a_la_carte?: boolean;
  buffet_by_weight?: boolean;
  rodizio?: boolean;
  others?: boolean;
  is_pending_onboarding?: boolean;
}

export interface Usuario {
  apelido: string;
  bot: number;
  cnpj: string;
  codigo?: number;
  collectiveAdmin: {
    origin_idi?: number | null;
    collective_id?: number | null;
    id: number;
    user_id?: number | null;
  }[];
  collective_id?: string;
  comissao?: number;
  cpf: string;
  data_alt: Date;
  data_inc: Date;
  email?: string;
  franchise_id: number;
  franchise_owner: number;
  franchise_selected: number;
  idi: number;
  inAnotherInstallation: boolean;
  instalacao?: Instalacao;
  login: string;
  nivel_acesso?: string | number;
  nome: string;
  permissions_json?: string | string[];
  sobrenome?: string;
  telefone?: string;
  timezone?: string;
  usuario_del?: number;
  usuario_inc?: number;
  waiter_password?: string;
  password?: string;
  permission_name?: string;
  kds_id?: number;
}

@Injectable({
  providedIn: "root",
})
export class UserService {
  private http = inject(HttpClient);

  getAuthenticatedUser(): Observable<Usuario> {
    return this.http.get<Usuario>("usuarios/authenticated");
  }
}
